export const CLIP_PREVIEW_TABS = {
  TRANSCRIPT: 'transcript',
  SUMMARY: 'summary'
} as const;

export type ClipPreviewTab = (typeof CLIP_PREVIEW_TABS)[keyof typeof CLIP_PREVIEW_TABS];

export const TAB_CONFIG = [
  {
    id: CLIP_PREVIEW_TABS.TRANSCRIPT,
    label: 'Transcription'
  },
  {
    id: CLIP_PREVIEW_TABS.SUMMARY,
    label: 'AI Summary'
  }
] as const;

export const TRANSCRIPT_MESSAGES = {
  GENERATING: 'Generating transcript...',
  NO_TRANSCRIPT: 'No transcript available for this clip',
  UNABLE_TO_PROCESS: 'Unable to process transcript'
} as const;

export const SKIP_SECONDS = 5 as const;
